import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltyError } from '@/Logalty/ui/molecules'

export const Step4Error = (): JSX.Element => {
  const { t } = useTranslation()
  const {
    logalty: { signStatus },
    navigateToOrigin,
  } = useBankAccount()

  return (
    <LogaltyError
      title={t(contractTranslation.changeBankAccount.step4.status.ko.title)}
      description={
        t(contractTranslation.changeBankAccount.step4.status.ko.description, {
          CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL
        })
      }
      buttonLabel={t(contractTranslation.changeBankAccount.step4.buttons.finish.label)}
      signStatus={signStatus}
      returnCallback={navigateToOrigin}
    />
  )
}
